<template>
<div>
  <div v-if="$route.name === 'transaction-contract-user-is-korgoo' || $route.name === 'transaction-contract-user-is-haigoo'" class="header-nav shadow-sm pr-3 pl-3 border-bottom">
      <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'transaction-contract-user-is-korgoo' }" :class="{ 'active': $route.name === 'transaction-contract-user-is-korgoo' }">บัญชีเจ้าหนี้ของคุณ</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'transaction-contract-user-is-haigoo' }" :class="{ 'active': $route.name === 'transaction-contract-user-is-haigoo' }">บัญชีลูกหนี้ของคุณ</router-link>
          </li>
      </ul>
  </div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
// more payment custom page css
.badge.badge-payment-date
{
    font-size:16px;
    border-radius:10px;
}

.table.table-payment
{
    margin: 10px auto;
    td {
        border-bottom:1px solid #dee2e6;
        background-color: #f0f0f0;
    }

    td:nth-child(1) {
        font-weight: bold;
    }
}
// end more payment custom page css
</style>
